import { toPx } from '../../../utils/toPx';
import { setUiTransitionStyles } from '../../utils/styles/styles';
import { rgba } from '../../utils/color';
import { css } from 'foundations-theming/utils';
const CHECKERBOARD_IMAGE = `<svg height="16" width="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path fill="%23F2F5F8" d="M0 0h16v16H0z"/>
      <g fill="%23CBD6E2">
        <path d="M8 8h8v8H8zM0 0h8v8H0z"/>
      </g>
    </g>
  </svg>`;
const getOpacityAffordance = ({
  size
}) => css(["background-image:url('data:image/svg+xml;utf8,", "');background-repeat:repeat;background-size:", ";"], CHECKERBOARD_IMAGE, toPx(size / 2.5));
export const getSquatchOuterStyles = props => {
  const {
    hovered,
    selected,
    opacity,
    size,
    theme,
    $cssStyles
  } = props;
  const styles = css(["opacity:", ";border-radius:", ";height:", ";width:", ";position:relative;", " ", " ", " ", ""], opacity ? getOpacityAffordance({
    size
  }) : 'initial', theme.borderRadius['100'], toPx(size), toPx(size), setUiTransitionStyles('box-shadow'), selected && css(["box-shadow:0 0 0 1px ", ",0 0 0 3px ", ";"], rgba(theme.color['fill-surface-default']), rgba(theme.color['border-accent-blue-default'])), hovered && !selected && css(["box-shadow:0 0 0 2px ", ",0 0 8px 0 ", ";"], rgba(theme.color['border-interactive-default']), rgba(theme.color['temp-future-fill-secondary-default'], 0.3)), Object.assign({}, $cssStyles));
  return styles;
};
// TODO why are we changing the color via rgba() instead of using it as is given it already has opacity?
export const getAfterStyles = props => css(["background-color:", ";border-radius:inherit;bottom:0;content:'';display:", ";left:0;position:absolute;right:0;top:0;"], rgba(props.theme.color['specialty-scrim'], 0.1), props.active ? 'block' : 'none');